import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRealtyValuationData, IRealtyValuationState, ITabs } from '../../types/realtyValuation';
import { IPricesFilters } from '../../repositories/newbuilding-estimate/entities/valuation_filters/PricesFilters';
import { ISalesFilters } from '../../repositories/newbuilding-estimate/entities/valuation_filters/SalesFilters';
import { EValuationTabs } from '../../containers/RealtyValuation/constants/tabs';

export const initialState: IRealtyValuationState = {
  isFetching: false,
  isError: false,
  data: null,
  pricesFiltersState: {} as IRealtyValuationState['pricesFiltersState'],
  salesFiltersState: {} as IRealtyValuationState['salesFiltersState'],
  tabs: null,
};

type TSuccessActionPayload = Partial<IRealtyValuationData>;

interface ISetPriceFilterPayload<Key extends keyof IPricesFilters> {
  filterName: Key;
  filterValue: IPricesFilters[Key];
}

interface ISetSalesFilterPayload<Key extends keyof ISalesFilters> {
  filterName: Key;
  filterValue: ISalesFilters[Key];
}

export const realtyValuationSlice = createSlice({
  name: 'realtyValuation',
  initialState,
  reducers: {
    requestAction: state => {
      state.isFetching = true;
    },
    failureAction: state => {
      state.isFetching = false;
      state.isError = true;
    },
    successAction: (state, action: PayloadAction<TSuccessActionPayload>) => {
      state.isFetching = false;
      state.isError = false;
      state.data = {
        ...(state.data as IRealtyValuationData),
        ...action.payload,
      };
    },
    setPriceFilterAction: (state, action: PayloadAction<ISetPriceFilterPayload<keyof IPricesFilters>>) => {
      const { filterName, filterValue } = action.payload;

      state.pricesFiltersState = {
        ...state.pricesFiltersState,
        [filterName]: filterValue,
      };
    },
    setSalesFilterAction: (state, action: PayloadAction<ISetSalesFilterPayload<keyof ISalesFilters>>) => {
      const { filterName, filterValue } = action.payload;

      state.salesFiltersState = {
        ...state.salesFiltersState,
        [filterName]: filterValue,
      };
    },
    setActiveTab: (state, action: PayloadAction<EValuationTabs>) => {
      state.tabs = {
        ...(state.tabs as ITabs),
        activeTab: action.payload,
      };
    },
  },
});

export const {
  reducer: realtyValuationReducer,
  actions: { requestAction, failureAction, successAction, setPriceFilterAction, setSalesFilterAction, setActiveTab },
} = realtyValuationSlice;
